<template>
  <!-- 试听 -->
  <div class="audition-page">
    <common-title
      v-if="!this.$root.miniprogram"
      :titleName="headerTitle"
      :bcColor="'#FEFEFF'"
      :zIndex="1000"
    />
    <div class="empty" v-if="!this.$root.miniprogram"></div>
    <div class="video-player" style="position: relative">
      <div id="player"></div>
      <div class="next-video" v-if="videoEndTool">
        <template v-if="nextVideoInfo.id">
          <span>本节课程已学完</span>
          <span class="video-title">下一节：{{ nextVideoInfo && nextVideoInfo.name }}</span>
          <div class="tool-btn">
            <div class="replay-btn" @click="replay">重新播放</div>
            <div class="next-btn" @click="nextPlayer">下一节</div>
          </div>
        </template>
        <template v-else>
          <span>本节课程已学完</span>
          <div class="tool-btn">
            <div class="replay-btn" @click="replay">重新播放</div>
          </div>
        </template>
      </div>
    </div>

    <div class="video-list">
      <div v-for="(item, index) in videoList" :key="index" class="videolistBox">
        <p
          :class="['title', idx === index ? 'title-active' : '']"
          :key="index"
          @click="handleChange(index)"
        >{{ item.name }}</p>
        <span class="videoDurUi">{{ getVideoTime(item.duration) }}</span>
      </div>
    </div>
    <CommonLoading :loading="loading" />
    <Foot />
  </div>
</template>

<script>
import loadJS from 'load-js';
import moment from 'moment';
import { RECORD_SITE_ID } from '@/utils/common';
import { reqCatalogs, reqClassNameType } from '@/api/courseDetail';
import { reqCourseDetail } from '../../api/courseDetail/index';
import { getBJYToken } from '@/api/live';
import CommonTitle from '@/components/header/CommonTitle.vue';
import CommonLoading from '@/components/commonComponents/CommonLoading.vue';
import Foot from '@/components/foot/privacy.vue';
import { setVideoDuration, gioPlatform } from '@/utils/tools';
let flag = false;
let startViewTime = 0;
export default {
  components: {
    CommonTitle,
    CommonLoading,
    Foot,
  },
  data() {
    return {
      idx: 0,
      videoList: [],
      videoEndTool: false,
      headerTitle: '试听视频',
      player: null,
      BJYPlayer: null,
      loading: false,
      playerType: '', // 播放器类别  CC BJY
      curriculumRespVO: {},
    };
  },

  methods: {
    async init() {
      this.loading = true;
      try {
        const res = await reqCatalogs(this.$route.query.containCurriculumId);
        this.videoList = res.data.videoInfoRespVOS;
        this.curriculumRespVO = res.data.curriculumRespVO;
        this.videoList.forEach((item, index) => {
          if (Number(this.$route.query.coursesId) === item.id) {
            this.idx = index;
          }
        });
        document.title = this.videoList[this.idx].name;
        this.headerTitle = this.videoList[this.idx].name;

        // 等待后端接口返回类型
        const { videoSource = 1 } = this.videoList[this.idx];
        this.playerType = videoSource === 1 ? 'CC' : 'BJY';
        // this.playerType = 'BJY';
        this.initData();
      } catch (e) {
        if (String(e).indexOf('Network Error') > -1) {
          this.$toast('无可用网络，请检查您的网络');
        } else {
          this.$toast('获取课表失败');
        }
      }
    },
    // 获取视频时长
    getVideoTime(time) {
      return setVideoDuration(time);
    },

    // 重新播放
    replay() {
      if (this.playerType === 'CC') {
        this.player.play();
        setTimeout(() => {
          document.getElementById('closeVtt')?.click?.();
        }, 1000);
      } else {
        this.videoEndTool = false;
        this.BJYPlayer.resume();
      }
    },

    handleChange(index) {
      this.loading = true;
      this.idx = index;
      this.videoEndTool = false;
      // eslint-disable-next-line no-unused-expressions
      this.player && this.player.destroy();
      document.title = this.videoList[this.idx].name;
      this.headerTitle = this.videoList[this.idx].name;
      const { videoSource = 1 } = this.videoList[this.idx];
      this.playerType = videoSource === 1 ? 'CC' : 'BJY';
      // this.createPlayer();
      this.initData();
    },
    initData() {
      document.getElementById('player').innerHTML = '';
      if (this.playerType === 'CC') {
        // CC的录播视频
        loadJS([
          {
            async: false,
            url: 'https://p.bokecc.com/player?siteid=096E928BC2A97B87&newversion=true',
          },
        ]).then(() => {
          this.setPlayerCallBack();
          this.gioReName();
        });
      } else {
        // 百家云的录播视频
        loadJS([
          {
            async: false,
            url: 'https://live-cdn.baijiayun.com/m-video-jssdk/0.0.5/playback/player.js',
          },
        ]).then(() => {
          this.createBJYPlayer();
          this.gioReName();
        });
      }
    },
    async createBJYPlayer() {
      const { vid, id } = this.videoList[this.idx];
      const res = await getBJYToken({
        vid,
        id,
        isAllowAudition: 1,
        userProductId: '',
      });
      const { token } = res.data;
      // eslint-disable-next-line
      this.BJYPlayer = new bjcPlayer('#player', {
        token,
        definition: 'high', // high 高清 low 低清
        disableDefinitionSwitch: true,
        onended: () => {
          // 结束
          this.onPlayerEnded();
        },
      });
      this.BJYPlayer.play(vid);
      this.loading = false;
      // 倍速
      // document.getElementsByClassName('bjc-player-video')[0].playbackRate = 2;
    },
    createPlayer() {
      this.playerEle = document.getElementById('player');

      this.idx %= this.videoList.length;
      const { idx, videoList } = this;

      const videoItem = videoList[idx];
      if (videoItem && videoItem.vid) {
        this.player = window.createCCH5Player({
          vid: videoItem.vid,
          siteid: RECORD_SITE_ID,
          playtype: 1,
          autoStart: true,
          width: '100%',
          height: '100%',
          open_barrage: false,
          parentNode: this.playerEle,
          isShare: false, // TODO：隐藏分享按钮，目前现在不生效，用CSS强制隐藏了
          vc: videoItem.id,
        });
      } else {
        this.$toast('视频地址出错,请稍后重试～');
      }
    },
    nextPlayer() {
      if (this.idx >= this.videoList.length) {
        this.idx = 0;
      } else {
        this.idx += 1;
      }
      // eslint-disable-next-line no-unused-expressions
      this.player && this.player.destroy();
      document.title = this.videoList[this.idx].name;
      this.headerTitle = this.videoList[this.idx].name;
      this.videoEndTool = false;
      // this.createPlayer();
      const { videoSource = 1 } = this.videoList[this.idx];
      this.playerType = videoSource === 1 ? 'CC' : 'BJY';
      // this.playerType = 'CC';
      this.initData();
    },

    setPlayerCallBack() {
      if (window.createCCH5Player) {
        this.createPlayer();
      } else {
        window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded;
      }
      window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded;
      window.on_CCH5player_ready = this.onPlayerReady;
      window.on_player_volumechange = this.onPlayerVolumeChange;
      window.on_CCH5player_ended = this.onPlayerEnded;
      window.on_CCH5player_play = this.onPlayerPlay;
      window.on_CCH5player_pause = this.onPlayerPause;
      // window.get_cc_verification_code = this.get_cc_verification_code;
    },

    onCCH5PlayerLoaded() {
      window.ccH5PlayerJsLoaded = true;
      this.createPlayer();
    },

    onPlayerReady() {
      this.loading = false;
      window.cc_js_Player.setVolume(0.3);
      this.player.play();
      setTimeout(() => {
        document.getElementById('closeVtt')?.click?.();
      }, 1000);
    },
    // 播放结束时回调
    onPlayerEnded() {
      // this.nextPlayer();
      if (this.idx < this.videoList.length - 1) {
        this.nextVideoInfo = this.videoList[this.idx + 1];
      } else {
        this.nextVideoInfo = {};
      }
      this.videoEndTool = true;
    },
    // 播放时回调
    onPlayerPlay() {
      this.videoEndTool = false;
      setTimeout(() => {
        console.log('onPlayerPlay')
        document.getElementById('closeVtt')?.click?.();
      }, 1000);
    },
    // 暂停播放是回调
    onPlayerPause() {
      // 回调
    },
    onPlayerVolumeChange() {
      // console.log('设置音量回调:  ', volume, vid);
    },
    /*gio埋点 */
    async gioReName() {
      const { isAllowAudition, name, vid } = this.videoList[this.idx];
      let { data } = await reqClassNameType(this.$route.query.coursesId);
      gio('track', 'listenCourse_event', {
        videoID_var: vid,
        videoName_var: name,
        videoType_var: '录播',
        isAudition_var: isAllowAudition ? '是' : '否',
        courseId_var: this.$route.query.coursesId.toString(),
        courseName_var: this.curriculumRespVO.name,
        classSize_var: data.className,
        platform_var: gioPlatform(this),
        enter_var: '课程详情页',
      });
    },
    //课程详情
    async courseDeatil() {
      const res = await reqCourseDetail(this.$route.query?.coursesId);
      if (res?.code === 0) {
        this.price = res?.data?.sellPrice;
        this.productId = res?.data?.productId;
        this.courseName = res?.data?.name;
        this.productCategoryName = res?.data?.productCategoryName.split('/').at(-1);
      }
    },
    uploadPageWxpose() {
      console.log('-----uploadPageWxpose------')
      if (flag && startViewTime) return;
      flag = true;
      const endViewTime = moment().unix();
      const diff = endViewTime - startViewTime;
      startViewTime = 0;
      const { isAllowAudition, name, vid, id } = this.videoList[this.idx];
      console.log('-----uploadPageWxpose2------')
      if (vid !== null) {
        console.log('-----uploadPageWxpose3------', {
          courseId_var: this.productId?.toString(),
          courseName_var: this.courseName,
          courseSubject_var: this.productCategoryName,
          coursePrice_var: this.price?.toString(),
          isLogin_var: 'true',
          platform_var: gioPlatform(this),
          browsingDuration_var: `${diff >= 600 ? 600 : diff}`,
          isAudition_var: isAllowAudition ? '是' : '否',
        })
        gio('track', 'videoDetailexit_event', {
          courseId_var: this.productId?.toString(),
          courseName_var: this.courseName,
          courseSubject_var: this.productCategoryName,
          coursePrice_var: this.price?.toString(),
          isLogin_var: 'true',
          platform_var: gioPlatform(this),
          browsingDuration_var: `${diff >= 600 ? 600 : diff}`,
          isAudition_var: isAllowAudition ? '是' : '否',
        });
      }
    },
  },
  beforeDestroy() {
    if (!this.$root.$data.isApp) {
      console.log('beforeDestroy');
      this.uploadPageWxpose();
    }
  },
  destroyed() {
    // eslint-disable-next-line no-unused-expressions
    this.player && this.player.destroy();
  },
  mounted() {
    flag = false;
    startViewTime = moment().unix();
    if (!this.$root.$data.isApp) {
      window.addEventListener('beforeunload', this.uploadPageWxpose);
    }
    this.init();
    this.courseDeatil();
    if (this.$root.miniprogram) {
      gio('track', 'PageAccess_event', {
        beforePageName_var: '课程详情',
        functionName_var: '播放页',
        platform_var: '启航考研小程序',
      });
    }
  },
};
</script>

<style scoped lang="scss">
.audition-page {
  // position: relative;
  .empty {
    width: 100%;
    height: 100px;
  }
  .video-list {
    max-height: calc(100vh - 100vw * (9 / 16) - 100px - 100px);
    padding-bottom: 200px;
    overflow-y: scroll;
    .videolistBox {
      display: flex;
      align-items: flex-end;
      padding: 36px;
      border-bottom: 2px solid #f5f5f5;
      .title {
        width: 90%;
        color: #808080;
        font-size: 25px;
        line-height: 28px;
      }
      .videoDurUi {
        color: #999;
        font-size: 25px;
      }
    }

    .title-active {
      color: $theme_color !important;
    }
  }

  .video-player {
    position: relative;

    #player,
    #playbackPlayer {
      display: flex;
      align-items: center;
      height: calc(100vw * (9 / 16));
      background: black;
    }

    .next-video {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9999;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: white;
      background: rgba(0, 0, 0, 0.5);

      .video-title {
        padding: 0 20%;
      }

      span {
        margin-bottom: 20px;
        font-size: 26px;
      }

      .tool-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 22px;

        div {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .replay-btn {
          width: 150px;
          height: 50px;
          color: #ff6c02;
          font-size: 26px;
          border: 2px solid #ff6c02;
          border-radius: 23px;
        }

        div:last-child {
          width: 150px;
          height: 50px;
          color: white;
          font-size: 26px;
          background: #ff6c02;
          border: 2px solid #ff6c02;
          border-radius: 23px;
        }

        .next-btn {
          margin-left: 24px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.audition-page {
  .adrPlayBtn {
    display: none !important;
  }
}
</style>
